<template>
  <div class="container">
    <div class="row">
      <div id="step3" class="col-xs-12 text-center">
        <registration-progress-bar
          title-reg="Administration Account"
          progress="80"
        ></registration-progress-bar>
        <br />
        <alert-info-step2 :form-type="currentFormType"></alert-info-step2>
        <br />
        <npi-search></npi-search>
        <npi-search-results></npi-search-results>
        <next-prev-buttons></next-prev-buttons>
      </div>
    </div>
    <scroll></scroll>
  </div>
</template>

<script>
import RegistrationProgressBar from "./forms/elements/RegistrationProgressBar.vue";
import AlertInfoStep2 from "./forms/elements/AlertInfoStep2.vue";
import NpiSearch from "./forms/NpiSearch.vue";
import NpiSearchResults from "./forms/NpiSearchResults.vue";
import NextPrevButtons from "./forms/elements/NextPrevButtons.vue";
import Scroll from "./forms/elements/Scroll.vue";

export default {
  components: {
    RegistrationProgressBar,
    AlertInfoStep2,
    NpiSearch,
    NpiSearchResults,
    NextPrevButtons,
    Scroll,
  },
  props: {
    formType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentFormType: this.formType,
    };
  },
};
</script>
